/**
 * Vídeo-recado (o vídeo redondo do WhatsApp, `ptvMessage`) gravado como GENERICA.
 *
 * O servidor baixa a mídia normalmente — a `url` do S3 está no conteúdo —, mas o
 * transformer não tem o tipo `ptvMessage` e grava a linha como GENERICA, que
 * vira bolha genérica. O invólucro cru sobreviveu no `conteudo`, então o tipo
 * real se resolve na leitura e o histórico inteiro se recupera sem backfill.
 *
 * Recebido sem base64 vai para a fila de reparo e chega ao vivo com
 * `midiaPendente` e SEM `url`; tem que virar VIDEO já, porque o
 * `MENSAGEM.MIDIA` só preenche o arquivo, não troca o tipo da bolha.
 * Sem `url` e sem pendência não há o que tocar: continua GENERICA.
 */
export function ehVideoRecado(conteudo: unknown): boolean {
    const c = conteudo as { ptvMessage?: unknown; url?: unknown; midiaPendente?: unknown } | null | undefined;
    if (!c?.ptvMessage) return false;
    const temUrl = typeof c.url === 'string' && c.url.length > 0;
    return temUrl || c.midiaPendente === true || c.midiaPendente === 'true';
}
